import { render } from "./AttachRemoveCorporateSitePlanComponent.vue?vue&type=template&id=639526b8"
import script from "./AttachRemoveCorporateSitePlanComponent.vue?vue&type=script&lang=js"
export * from "./AttachRemoveCorporateSitePlanComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__